// import React from 'react';
import { DateTime } from 'luxon';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { getStoryPages } from '../actions';
import { selectEntity } from '../../entities/selectors';
import { useStoryPagesSWR } from '../api';


const getPages = (input) => {

  // Create a map of included items by type and ID for quick lookup
  const includedMap = {};
  input.included.forEach(item => {
    if (!includedMap[item.type]) includedMap[item.type] = {};
    includedMap[item.type][item.id] = item;
  });

  // Get the page relationships from the main data object
  const pageRefs = input.data.relationships.pages.data;

  // Build the desired output array
  const result = pageRefs.map(pageRef => {
    const page = includedMap['pages'][pageRef.id];
    const attributes = page.attributes;

    // Get media references from page relationships
    const mediaRefs = page.relationships.media.data;

    return {
      id: attributes.id,
      position: attributes.position,
      "horizontal-orientation": attributes["horizontal-orientation"],
      "lock-version": attributes["lock-version"],
      "updated-at": attributes["updated-at"],
      "created-at": attributes["created-at"],
      media: mediaRefs,
      meetings: [] // Based on your example output, this is empty
    };
  });
  return result

}

const StoryPageCollection = ({ children, storyId, storyPages }) => {
  const { data, error } = useStoryPagesSWR(storyId, false);
  const mainData = data?.data
  let updatedPages = (storyPages.length === 0 && data?.data?.data?.relationships?.pages?.data?.length > 0) ? getPages(mainData) : storyPages

  return children({ loading: !data && !error, storyPages: updatedPages, storyId });
};

StoryPageCollection.propTypes = {
  storyPages: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      type: PropTypes.string,
    })
  ),
  children: PropTypes.func.isRequired,
  getStoryPages: PropTypes.func.isRequired,
};

StoryPageCollection.defaultProps = {
  storyPages: [],
};

export const selectStoryPagesWithMedia = ({ state, storyId }) => {
  const story = selectEntity({ state, type: 'stories', id: storyId });
  if (!story) return undefined;
  return (story.pages || [])
    .map(page => selectEntity({ state, ...page }))
    .filter(page => {
      if (!page) return false;
      if (page.optimisticDeleted) return false;
      return !!(page.media && page.media.length);
    })
    .sort((p1, p2) => {
      if (p1.position === p2.position) {
        return DateTime.fromISO(p2['updated-at']) - DateTime.fromISO(p1['updated-at']);
      }
      return p1.position - p2.position;
    });
};

const mapStateToProps = (state, { storyId }) => ({
  storyPages: selectStoryPagesWithMedia({ state, storyId }),
});

export default connect(mapStateToProps, { getStoryPages })(StoryPageCollection);
